// Datos de Conciliación. El grid siempre; los folios solo de la celda abierta.
import { useQuery } from '@tanstack/react-query';
import { settlementApi } from '@/api/services/retail-wizard/backoffice';

const KEY = ['retail-admin', 'conciliacion'] as const;

/** El rango del mockup: los últimos 7 días. Lo resuelve el silo y lo devuelve en la respuesta. */
function lastSevenDays(): { from: string; to: string } {
    const iso = (d: Date) =>
        `${String(d.getFullYear())}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    const to = new Date();
    const from = new Date();
    from.setDate(from.getDate() - 6);
    return { from: iso(from), to: iso(to) };
}

export function useReconciliation() {
    const range = lastSevenDays();
    return useQuery({
        queryKey: [...KEY, range],
        queryFn: () => settlementApi.getReconciliation(range),
        staleTime: 60_000,
    });
}

export function useFolios(selected: { date: string; storeId: string } | null) {
    return useQuery({
        queryKey: [...KEY, 'folios', selected],
        queryFn: () => settlementApi.getFolios(selected?.date ?? '', selected?.storeId ?? ''),
        enabled: selected !== null,
        staleTime: 60_000,
    });
}
